export const fileSizeFormat = (bytes: number, decimal = 2): string => {
  const unit = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return (!bytes && '0 Bytes') || `${(bytes / 1024 ** i).toFixed(decimal)} ${unit[i]}`;
};
